import name from './name'
import birthday from './birthday'
import identityCard from './identityCard'
import username from './username'
import i18nphone from './i18nphone'
import enName from './enName'
import zhName from './zhName'
import mixFullName from './mixFullName'

export default {
  name: name,
  birthday: birthday,
  identityCard: identityCard,
  username: username,
  i18nphone: i18nphone,
  enName,
  zhLastName: zhName('lastName'),
  zhFirstName: zhName('firstName'),
  mixFullName
}
